import type { FunctionComponent } from 'react';

import { useFavorites, useLoadedEvent, useRequestEvent, useToggleEvent } from '../hooks';

export const FavoritesProvider: FunctionComponent = () => {
  const { favorites, request, toggle } = useFavorites();
  useLoadedEvent(favorites);
  useRequestEvent(request);
  useToggleEvent(toggle);

  return null;
};
